import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/icon_loading.png'


const _withScopeId = n => (_pushScopeId("data-v-5c5c1696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-mask" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {},
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "loading-text" }

import { ref } from 'vue'





export default /*#__PURE__*/_defineComponent({
  __name: 'loading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('chat.loadingText')), 1)
  ]))
}
}

})